export default "__VITE_ASSET__Dyb2tiCA__"